<div class="hotels-map">
  @if (loading$ | async) {
    <div class="hotels-map__map-loading"></div>
  } @else {
    <google-map #hotelsMap height="100%" width="100%" [center]="center" [options]="mapOptions"
      (mapClick)="resetCurrentMarker()">

      @for (marker of markers; track marker) {
        <map-marker #currentMarker="mapMarker" [position]="marker.position" [title]="marker.title"
          [id]="marker.id" [options]="marker.options" (mapClick)="openInfo(currentMarker, marker)">
        </map-marker>
      }
      @for (poi of poiMarkers; track poi) {
        <map-marker #poiMarker="mapMarker" [position]="poi.position" [title]="poi.title" [id]="poi.id"
          [options]="poi.options" (mapClick)="openPoiInfo(poiMarker, poi)">
        </map-marker>
      }
      <map-info-window [options]="infoWindowOptions" (closeclick)="closeHotelMapInfoWindow()">
        @if (markerInfo?.type === 'location') {
          <am-hotels-map-info-window [currency]="markerInfo.info?.currency" [data]="markerInfo.info"
            [query]="query$ | async" [brand]="brand">
          </am-hotels-map-info-window>
        }
        @if (markerInfo?.type === 'poi') {
          <h6>{{ markerInfo.info }}</h6>
        }
      </map-info-window>
    </google-map>
    <div class="hotels-map__close-map" (click)="closeMap()">
      <mb-icon class="icon-close" icon="close"></mb-icon>
    </div>
  }
</div>